import React, { useState, useContext } from 'react';
import { useEffect } from 'react';
import Button from '@sabre/spark-react-core/button';
import { func, array, string } from 'prop-types';
import useApi from '../../../api-wrapper/use-api.js';
import {
   URL_CORE_PRICING_DELETE_DISTRIBUTION,
   URL_CORE_PRICING_WORKING_FARES,
} from '../../../end-points.js';

const DistributionDeleteConformation = ({
   handleCancelButtonClick,
   deletedDistributionList,
   handleUpdateDistributionTable,
   handleError,
   selectedScreen,
}) => {
   const [distributionDeleteApi, setDistributionDeleteApi] = useApi({});
   const [isDelete, setIsDelete] = useState(false);
   useEffect(() => {
      if (
         distributionDeleteApi &&
         !distributionDeleteApi.error &&
         !distributionDeleteApi.isLoading &&
         isDelete
      ) {
         handleUpdateDistributionTable(
            selectedScreen === 'Fares'
               ? deletedDistributionList.distributionGroupNumber.workingFares
               : deletedDistributionList.dgNumber
         );
      } else if (distributionDeleteApi.error) {
         handleError(distributionDeleteApi.error);
      }
   }, [distributionDeleteApi.isLoading]);
   const parsingObject = (data) => {
      delete data.screen;
      return data;
   };
   const handleDeleteConformationButtonClick = () => {
      setIsDelete(true);
      setDistributionDeleteApi({
         method: 'DELETE',
         url:
            selectedScreen === 'Fares'
               ? URL_CORE_PRICING_WORKING_FARES
               : URL_CORE_PRICING_DELETE_DISTRIBUTION,
         data: parsingObject(
            selectedScreen === 'Fares'
               ? deletedDistributionList.distributionGroupNumber
               : deletedDistributionList
         ),
      });
   };
   return (
      <div className='distribution-delete-conformation-root'>
         <div className='row spark-bold delete-conform-text'>{`  ${
            selectedScreen === 'Reference'
               ? 'Are you sure you want to delete these rows and all data within them ?'
               : 'All data within them ?'
         }`}</div>
         <div className='row spark-flex spark-pad-t-2 alignment-right'>
            <Button
               name='dg-cancel-button'
               className='spark-btn--secondary spark-mar-r-1'
               size={Button.SIZE.SMALL}
               onClick={handleCancelButtonClick}
            >
               CANCEL
            </Button>
            <Button
               name='dg-upload-button'
               className='spark-btn--primary'
               size={Button.SIZE.SMALL}
               onClick={handleDeleteConformationButtonClick}
            >
               Delete
            </Button>
         </div>
      </div>
   );
};
DistributionDeleteConformation.prototype = {
   deletedDistributionList: array,
   handleCancelButtonClick: func,
   handleUpdateDistributionTable: func,
   handleError: func,
   selectedScreen: string,
};
export default DistributionDeleteConformation;
